import React, { Component } from "react";
import { connectHits, InstantSearch } from "react-instantsearch-dom";
import styles from "assets/jss/material-dashboard-pro-react/components/tableStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import InventoryTable from "../../components/Table/InventoryTable";
import _ from "lodash";
import ItemDetails from "./ItemDetailDrawer/ItemDetails";
import PricingModal from "./PricingModal";
import { connect } from "react-redux";
import GlobalProductModal from "./GlobalProductModal/GlobalProductModal";

class SearchTable extends Component {
  state = {
    products: [],
    showDrawer: false,
    showPricingModal: false,

    productSkuId: "",
    productQuantity: "",
    productIdx: null,
    isAddingNewItem: false,
    canSetStock: false,
    canEditPrice: false,
    canEditDeals: false,
    showGlobalProductModal: false,
  };

  onRowClick = (row, idx) => {
    const { skuId, quantity } = { skuId: row.sku_id, quantity: row.quantity };
    const { contextOpened } = this.state;
    if (contextOpened) {
      return;
    }
    this.setState({
      showDrawer: true,
      productSkuId: skuId,
      productIdx: idx,
      productQuantity: quantity,
    });
  };

  onGlobalProductRowClick = (row, idx) => {
    if (this.props.currentUser.type !== "saucey_admin") {
      console.log('insufficient perms', this.props.currentUser.type);
      return;
    }
    const { skuId, quantity } = { skuId: row.sku_id, quantity: row.quantity };
    this.setState({
      showGlobalProductModal: true,
      productSkuId: skuId,
      productIdx: idx,
      productQuantity: quantity,
    });
  };

  setContextOpened = (opened) => {
    this.setState({ contextOpened: opened });
  };
  closeGlobalProductModal = () => {
    this.setState({
      showGlobalProductModal: null,
      productSkuId: null,
      productIdx: null,
    });
  };
  openPricingModal = (idx, sku, isAddingNewItem) => {
    this.setState({
      showPricingModal: true,
      productSkuId: sku,
      productIdx: idx,
      isAddingNewItem,
    });
  };
  closePricingModal = () => {
    this.setState({
      showPricingModal: false,
      productSkuId: null,
      productIdx: null,
    });
  };
  handleCloseItemDrawer = () => {
    this.setState({ showDrawer: false, productSkuId: null, productIdx: null });
  };

  componentDidMount() {
    if (this.props.hits) {
      this.setState({ products: this.props.hits });
    }
    this.setPermissions();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!_.isEqual(prevProps.hits, this.props.hits)) {
      this.setState({ products: this.props.hits });
    }
    if (
      !this.props.stores ||
      !this.props.activeStore ||
      !this.props.currentUser
    ) {
      return;
    }
    if (
      prevProps.activeStore !== this.props.activeStore ||
      prevProps.currentUser !== this.props.currentUser ||
      this.props.stores !== prevProps.stores
    ) {
      this.setPermissions();
    }
  }
  setPermissions() {
    let canSetStock = false;
    let canEditPrice = false;
    let canEditDeals = false;
    if (this.props.stores && this.props.activeStore && this.props.currentUser) {
      if (this.props.currentUser.type === "saucey_admin") {
        canSetStock = true;
        canEditPrice = true;
        canEditDeals = true;
      } else {
        if (
          this.props.currentUser.permissions &&
          this.props.currentUser.permissions.length
        ) {
          let activeStoreID = "";
          for (let i = 0; i < this.props.stores.length; i++) {
            if (this.props.activeStore === this.props.stores[i].store_id) {
              activeStoreID = this.props.stores[i].id;
              break;
            }
          }
          if (activeStoreID) {
            for (
              let i = 0;
              i < this.props.currentUser.permissions.length;
              i++
            ) {
              if (
                this.props.currentUser.permissions[i].seller === activeStoreID
              ) {
                const storePerm = this.props.currentUser.permissions[i]
                  .permissions;
                if (storePerm.includes("pricing")) {
                  canEditPrice = true;
                }
                if (storePerm.includes("deals")) {
                  canEditDeals = true;
                }
                if (storePerm.includes("stock")) {
                  canSetStock = true;
                }
                if (storePerm.includes("*")) {
                  canEditPrice = true;
                  canEditDeals = true;
                  canSetStock = true;
                }
                break;
              }
            }
          }
        }
      }
    }
    this.setState({ canSetStock, canEditDeals, canEditPrice });
  }

  updateLocal = (idx, field, newValue) => {
    let { products } = this.state;
    products[idx][field] = newValue;
    this.setState({ products });
  };

  render() {
    const { classes, showAllItems, activeStoreObject, currentUser } = this.props;
    const {
      products,
      showDrawer,
      showPricingModal,
      productSkuId,
      productIdx,
      productQuantity,
      isAddingNewItem,
      canSetStock,
      canEditPrice,
      canEditDeals,
      showGlobalProductModal,
    } = this.state;
    return (
      <div>
        {showGlobalProductModal && productSkuId && (
          <GlobalProductModal
            closeGlobalProductModal={this.closeGlobalProductModal}
            skuId={productSkuId}
            idx={productIdx}
          />
        )}
        {showDrawer && (
          <ItemDetails
            skuId={productSkuId}
            idx={productIdx}
            updateLocal={this.updateLocal}
            close={this.handleCloseItemDrawer}
            productQuantity={productQuantity}
            canSetStock={canSetStock}
            canEditPrice={canEditPrice}
            canEditDeals={canEditDeals}
            user={currentUser}
          />
        )}
        {showPricingModal && canEditPrice && (
          <PricingModal
            skuId={productSkuId}
            idx={productIdx}
            open={showPricingModal}
            isAddingNewItem={isAddingNewItem}
            updateLocal={this.updateLocal}
            closePricingModal={this.closePricingModal}
          />
        )}
        <InventoryTable
          onRowClickProxy={
            showAllItems
              ? (idx) => {
                  this.onGlobalProductRowClick(products[idx], idx);
                }
              : (idx) => {
                  this.onRowClick(products[idx], idx);
                }
          }
          striped
          updateLocal={this.updateLocal}
          openPricingModal={this.openPricingModal}
          setContextOpened={this.setContextOpened}
          showAllItems={showAllItems}
          customCellClasses={[classes.noPadding]}
          customClassesForCells={[7]}
          customHeadCellClasses={[classes.noPadding]}
          customHeadClassesForCells={[7]}
          hits={products}
          canSetStock={canSetStock}
          canEditPrice={canEditPrice}
          canEditDeals={canEditDeals}
        />
      </div>
    );
  }
}

const SearchableTable = connectHits(SearchTable);

export default connect(
  (state) => ({
    activeStore: state.app.activeStore,
    activeStoreObject: state.app.activeStoreObject,
    currentUser: state.app.user,
    stores: state.app.stores,
  }),
  {}
)(withStyles(styles)(SearchableTable));
